import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { getHumanReadableSerialNumber } from 'lib/cards';

import type { TokenMetas_anyCard } from './__generated__/index.graphql';

type Props = {
  card: TokenMetas_anyCard;
  separator?: string;
};

export const TokenMetas = ({ card, separator }: Props) => {
  return (
    <>
      {[card.sportSeason.name, separator, getHumanReadableSerialNumber(card)]}
    </>
  );
};

TokenMetas.fragments = {
  anyCard: gql`
    fragment TokenMetas_anyCard on AnyCardInterface {
      slug
      sportSeason {
        name
      }
      ...getHumanReadableSerialNumber_anyCard
    }
    ${getHumanReadableSerialNumber.fragments.anyCard}
  ` as TypedDocumentNode<TokenMetas_anyCard>,
};
